import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="22" height="13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 0c1.3 0 2.5.7 3.1 1.8l5.7 9.8c1 1.7 3.5 1.7 4.5 0L19 1.8C19.5.7 20.7 0 22 0" fill="#F7F7F7" /></svg>);